// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1emau","left":"styles_left__3o9v4"};